import React, { Fragment } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import '../modals.css';

const SaveGridRow = ( { close, setSaving, onCancel, setId, rid } ) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Stop!</Col>
                </Row>
                <Row className='py-2'>
                    <Col>
                        You've made changes and are about to lose them. What would you like us to do?
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col xs='auto'>
                        <Button size='sm' variant='outline-primary' onClick={ ( e ) => { console.log( 'clicked modal save' ); e.stopPropagation(); setId( rid ); setSaving( true ); close(); } }>Save It!</Button>
                    </Col>
                    <Col xs='auto'>
                        <Button size='sm' variant='outline-primary' onClick={ () => { setId( rid ); onCancel( true ); close(); } }>Discard the Changes</Button>
                    </Col>
                </Row>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( SaveGridRow );